@if (pageData.layout == GalleryLayout.CAROUSEL) {
  @if (items) {
    <div class="carousel-wrap">
      <owl-carousel-o [options]="pageData.carouselConfig">
        @for (item of items; track item; let i = $index) {
          <ng-template carouselSlide [dotContent]="item">
            @if ((templates$|async)?.[pageData.entityPreviewVar]) {
              <div [innerHtml]="(templates$|async)[pageData.entityPreviewVar] | replaceTokensArray: {keys: item, previewVar: pageData.entityPreviewVar} | safe: 'html'"></div>
            } @else {
              <div>
                <img no-image [src]="item.preview_image_s" alt="">
              </div>
              <div>
                <h6>{{item.seo_title_s}}</h6>
                <p>{{item.seo_description_s}}</p>
                <a [routerLink]="item.preview_link_s" translate>read more > </a>
              </div>
            }
          </ng-template>
        }
      </owl-carousel-o>
    </div>
  }
}
@if (pageData.layout == GalleryLayout.FLAT) {
  <div   [ngStyle]="{'padding-right': gridInfo['gutterHorizontal'], 'padding-left': gridInfo['gutterHorizontal']}">
    <ul [ngClass]="key" class="list-unstyled px-0 row row-cols-{{gridInfo['itemsPerRow']}} justify-content-{{gridInfo['justifyContent']}}"
      [ngStyle]="{'margin-right': '-'+(gridInfo['gutterHorizontal']), 'margin-left': '-'+(gridInfo['gutterHorizontal'])}">
      @for (item of items; track item; let i = $index; let first = $first) {
        <li [ngClass]="{'active' : first , 'col' : gridInfo['itemsPerRow'], 'col-auto' : !gridInfo['itemsPerRow']}"
          [ngStyle]="{'padding': gridInfo['gutterHorizontal']+' '+ gridInfo['gutterVertical']}">
          @if ((templates$|async)?.[pageData.entityPreviewVar]) {
            <div [innerHtml]="(templates$|async)[pageData.entityPreviewVar] | replaceTokensArray: {keys: item, previewVar: pageData.entityPreviewVar} | safe: 'html'"></div>
          } @else {
            <li  class="p-3 m-1 card-default d-flex flex-column" >
              <div>
                <img no-image [src]="item.preview_image_s" alt="">
              </div>
              <div>
                <h6>{{item.seo_title_s}}</h6>
                <p>{{item.seo_description_s}}</p>
                <a [routerLink]="item.preview_link_s" translate>read more > </a>
              </div>
            </li>
          }
        </li>
      }
    </ul>
  </div>
}



